import { Box } from "@chakra-ui/react";
import Loader from "component/Loader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as widgets from "redux/actions/widget";
import * as widgetChats from "redux/actions/chats";
import Footer from "component/Footer";
import Header from "component/Header";
import Chats from "component/Chats";
import { addUuid } from "redux/utils";
import { useNavigate, useParams } from "react-router-dom";
import { getSession } from "redux/services";
import NotFound from "./NotFound";

function extractDomain(url) {
  const hostname = new URL(url).hostname;
  const parts = hostname.split(".");
  if (parts.length > 2) {
    return parts.slice(-2).join(".");
  }
  return hostname;
}
const Widget = () => {
  const dispatch = useDispatch();
  const { loading, widget, widgetSuccess } = useSelector(
    (state) => state?.widgets
  );
  const { dataLoading, chats } = useSelector((state) => state?.chats);
  const [dataPadding, setDataPadding] = useState(widget?.message_size);
  const [showNotFound, setShowNotFound] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(widgets?.getWidget(id));
  }, [dispatch, id]);


  useEffect(() => {
    switch (widget?.message_size) {
      case "small":
        setDataPadding("5px");
        break;
      case "medium":
        setDataPadding("7px");
        break;
      case "large":
        setDataPadding("9px");
        break;
      default:
        setDataPadding("5px");
        break;
    }
  }, [widget?.message_size]);

  // ------------------------------------------------------------------------
  useEffect(() => {
    const sessionId = getSession();
    if (sessionId) dispatch(widgetChats.getChats(sessionId));
    else {
      const id = addUuid();
      dispatch(widgetChats.getChats(id));
    }
  }, [dispatch]);

  // -------------------------------------------------------------------------

  useEffect(() => {
    if (window.self !== window.top) {
      const origins = window.location.ancestorOrigins;
      if (origins && origins.length > 0) {
        const domain = extractDomain(origins[origins.length - 1]);
        let allowed_domains = widget?.allowed_domains;
        if (widget && allowed_domains && !allowed_domains?.includes(domain)) {
          setShowNotFound(true);
        } else {
          setShowNotFound(false);
        }
      }
    }
  }, [navigate, widget]);

  // ---------------------------------------------------------------------------------------

  useEffect(() => {
    if (widgetSuccess) {
      const isWidgetInvalid = id !== widget?.public_key || !widget?.widget_status;
      console.log(isWidgetInvalid, "::isWidgetInvaliddd.....");

      // Set showNotFound based on the widget validity
      setShowNotFound(isWidgetInvalid);
    }
  }, [widgetSuccess, widget, id]);


  // ---------------------------------------------------------------------------------------
  if (loading) {
    return <Loader isCenter />;
  }

  return (
    <Box className="widget-custom-class-side">
      <Box className="widget">
        <Box className="widget-side-div-2">
          {showNotFound ? (
            <NotFound />
          ) : (
            <Box
              className="widget-side-div-inner"
              style={{ backgroundColor: widget?.bot_background }}
            >
              <>
                <Header widget={widget} />
                {dataLoading ? (
                  <Loader />
                ) : (
                  <Chats
                    widget={widget}
                    chats={chats}
                    dataPadding={dataPadding}
                    id={id}
                  />
                )}
                <Box className="widget-side-div-outer-textarea">
                  <Footer widget={widget} id={id} />
                </Box>
              </>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Widget;
